<template>
    <console-content max-width="1024px" class="shop-product-view">
            <div class="headline text-start mt-8">회원 상세</div>

            <v-card class="mt-4">
                <v-card-title class="subtitle-2 font-weight-bold">회원정보</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model="user.username" label="아이디" placeholder=" " hide-details :disabled="!!user._id"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-password-field v-model="user.password" label="비밀번호" placeholder=" " hide-details></v-password-field>
                        </v-col>
                    </v-row>

                    <v-row class="mt-3">
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model="user.name" label="이름" placeholder=" " hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-select v-model="user._level" label="회원등급" :items="levels" item-text="name" item-value="_id" placeholder=" " hide-details @change="setScope"></v-select>
                        </v-col>
                    </v-row>

                    <v-row class="mt-3">
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model="user.phone" label="연락처" placeholder=" " hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model="user.email" label="이메일" placeholder=" " hide-details></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="mt-3">
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model="user.postcode" label="우편번호" placeholder=" " hide-details readonly @click="$refs['daum-postcode'].open()"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="mt-3">
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model="user.address1" label="기본주소" placeholder=" " hide-details readonly @click="$refs['daum-postcode'].open()"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model="user.address2" label="상세주소" placeholder=" " hide-details></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="mt-3">
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model="user.code" label="발권코드" placeholder=" " hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card class="mt-3 pb-1" :disabled="!user._id">
                <v-card-title>
                    <v-row>
                        <v-col cols="12" md="6" class="py-0">
                            <span class="subtitle-2">Cash</span>
                            <span class="caption primary--text ml-1">{{ user.cash.format() }}원</span>
                        </v-col>
                        <v-col cols="12" md="6" class="py-0">
                            <v-row align="center">
                                <v-col class="py-0 pr-0">
                                    <v-text-field v-show="false" v-model="cash.price"></v-text-field>
                                    <v-text-field v-model="cash.priceFormat" label="금액" placeholder=" " hide-details class="pt-0" @input="value => { cash.price = parseInt(value.replace(/[^0-9\-.]/g, '') || 0); cash.priceFormat = cash.price.format(); }" ></v-text-field>
                                </v-col>
                                <v-col class="py-0 pr-0">
                                    <v-text-field v-model="cash.remark" label="비고" placeholder=" " hide-details class="pt-0"></v-text-field>
                                </v-col>
                                <v-col cols="auto" class="py-0">
                                    <v-btn color="primary" small @click="charge">
                                        <v-icon small>mdi-plus</v-icon>충전
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-0">
                    <v-data-table :items="cashes" :headers="cashesHeaders" hide-default-footer disable-pagination disable-sort>
                        <template v-slot:item.createdAt="{ item }">
                            {{ item.createdAt.toDateTime() }}
                        </template>
                        <template v-slot:item.price="{ item }">
                            {{ item.price.format() }}원
                        </template>
                        <template v-slot:item.remain="{ item }">
                            {{ item.remain.format() }}원
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-divider/>
                <v-pagination v-model="page" :length="pageCount" total-visible="9" class="mt-1" @input="search"></v-pagination>
            </v-card>

            <v-row justify="center" class="mt-4">
                <v-col md="auto" sm="auto">
                    <v-btn color="primary" @click="save">저장</v-btn>
                </v-col>
            </v-row>

            <daum-postcode ref="daum-postcode" @input="({ postcode, address }) => { user.postcode = postcode; user.address1 = address; }"></daum-postcode>

    </console-content>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import vPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import ConsoleContent from "@/components/console/console-content.vue";

export default {
    components: {
        DaumPostcode,
        ConsoleContent,
        vPasswordField
    },
    props: {
        isCreate: { type: Boolean, default: false },
        isClone: { type: Boolean, default: false },
    },
    data() {
        return {
            levels: [],
            user: {
                _id: this.$route.params._user,
                _level: undefined,

                username: undefined,
                password: undefined,
                name: undefined,
                phone: undefined,
                email: undefined,

                postcode: undefined,
                address1: undefined,
                address2: undefined,

                cash: 0,
            },
            
            cash: {
                _user: this.$route.params._user,
                price: 0,
                priceFormat: 0,
                remark: null
            },

            page: 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            cashes: [],
            cashesHeaders: [
                { text: "날짜", align: "center", value: "createdAt" },
                { text: "금액", align: "center", value: "price" },
                { text: "남은금액", align: "center", value: "remain" },
                { text: "비고", align: "center", value: "remark" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            // 회원등급 조회
            var { levels } = await api.console.levels.getLevels();
            this.levels = levels;
            
            // 회원정보 조회
            if(this.user._id){
                var { user } = await api.console.users.get(this.user);
                this.user = user;
                if(this.isClone) this.user._id = undefined;
            }

            // 캐시내역 조회
            await this.search();

        },
        async save(){
            try{
                this.user._id 
                ? await api.console.users.put({
                    ...this.user,
                    password: CryptoAES.encrypt(this.user.password)
                }) 
                : await api.console.users.post({
                    ...this.user,
                    password: this.user.password ? CryptoAES.encrypt(this.user.password) : undefined
                });

                alert("저장되었습니다");
                this.$router.go(-1);
            }
            catch(error){
                console.error(error);
            }
        },
        
        async search(){
            if(this.user._id){
                var { summary, cashes } = await api.console.users.cashes.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit
                    },
                    params: {
                        _user: this.user._id
                    }
                });
    
                this.cashes = cashes;
                this.summary = summary;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            }
        },

        async charge(){
            await api.console.users.cashes.post(this.cash);
            alert("충전되었습니다");
            this.search();
        },

        setScope(input){
            this.user.scope = [(this.levels.find((level) => level._id === input))?.code];
        }
    }
}
</script>
